/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppointmentDTO } from '../models/AppointmentDTO'
import type { CancelAppointmentDTO } from '../models/CancelAppointmentDTO'
import type { NoShowDTO } from '../models/NoShowDTO'
import type { RescheduleAppointmentDTO } from '../models/RescheduleAppointmentDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenCandidateAppointmentsService {
    /**
     * Cancel Appointment
     * Cancel the appointment, which frees the slot for other patients.
     *
     * The status is left to the ``BOOKING_CANCELLED`` webhook rather than written
     * here — see the module docstring.
     * @returns AppointmentDTO Successful Response
     * @throws ApiError
     */
    public static cancelAppointmentCandidatesCandidateIdAppointmentCancelPost({
        candidateId,
        requestBody
    }: {
        candidateId: string
        requestBody: CancelAppointmentDTO
    }): CancelablePromise<AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidates/{candidate_id}/appointment/cancel',
            path: {
                candidate_id: candidateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Reschedule Appointment
     * Move the appointment to a new slot.
     *
     * Enforces the same 4pm ET cutoff as the patient-facing path. A coordinator is
     * more trusted than a patient, but the cutoff exists because the PMs cannot
     * service those slots — so bypassing it here would book a call nobody can take.
     *
     * Cal.com issues a NEW booking uid on reschedule and cancels the old one, so
     * the new uid is persisted immediately. Not doing so would leave our row
     * joined to a cancelled booking, and every subsequent webhook would fail to
     * match it.
     * @returns AppointmentDTO Successful Response
     * @throws ApiError
     */
    public static rescheduleAppointmentCandidatesCandidateIdAppointmentReschedulePost({
        candidateId,
        requestBody
    }: {
        candidateId: string
        requestBody: RescheduleAppointmentDTO
    }): CancelablePromise<AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidates/{candidate_id}/appointment/reschedule',
            path: {
                candidate_id: candidateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Mark Appointment No Show
     * Mark the attendee (or host) absent — D17.
     *
     * ## Why this writes the status itself
     *
     * It originally left the status to the ``BOOKING_NO_SHOW_UPDATED`` webhook, on
     * the same single-writer principle as cancel. That does not work: observed on
     * deiddev, Cal.com records the absence but no such delivery arrives for an
     * **API-initiated** mark-absent, so the row sat at ``confirmed`` indefinitely
     * while Cal.com said the patient was absent. Cancel is unaffected — its
     * ``BOOKING_CANCELLED`` delivery does arrive — which is what makes this
     * specific to this trigger rather than a webhook outage.
     *
     * Same shape as reschedule, and for the same reason: when Cal.com will not
     * tell us, we record what we know. A later duplicate delivery is harmless —
     * it carries the same status, and ``should_apply`` handles ordering.
     *
     * ## Why it reads the booking back first
     *
     * ``mark-absent`` answers 200 while recording nothing if the payload names the
     * wrong person (note 4 in the client docstring — this is exactly how the
     * original payload bug hid). Since we now write ``no_show`` locally off the
     * back of it, trusting the 2xx would replace one silent lie with another: our
     * row claiming a no-show that Cal.com never recorded.
     * @returns AppointmentDTO Successful Response
     * @throws ApiError
     */
    public static markAppointmentNoShowCandidatesCandidateIdAppointmentNoShowPost({
        candidateId,
        requestBody
    }: {
        candidateId: string
        requestBody: NoShowDTO
    }): CancelablePromise<AppointmentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidates/{candidate_id}/appointment/no-show',
            path: {
                candidate_id: candidateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
}
